import React from "react"
import { storyblokEditable } from "gatsby-source-storyblok"

const Spacer = ({ blok }) => (
  <div
    {...storyblokEditable(blok)}
    key={blok._uid}
    className="spacer"
    style={{
      "--height-desktop": `${blok.height_desktop || 0}px`,
      "--height-tablet": `${blok.height_tablet || 0}px`,
      "--height-mobile": `${blok.height_mobile || 0}px`,
    }}
  />
)

export default Spacer
